<template>
  <q-footer data-test-id="mobile-footer">
    <slot name="default" />
    <q-tabs
      v-if="$q.screen.lt.sm"
      v-model="tab"
      dense
      :active-color="$isColorDark(currentSite.primaryColor) ? 'white' : 'black'"
      indicator-color="transparent"
      :class="{
        'overflow-visible': siteSelectorShown && $q.platform.is.ios,
        'white-transparent-50': $isColorDark(currentSite.primaryColor),
        'dark-transparent-50': !$isColorDark(currentSite.primaryColor)
      }"
    >
      <q-tab
        v-for="navigation in mobileMenuNavigations"
        :key="navigation.id"
        :name="navigation.name"
        :icon="navigation.mobileMenuIcon"
        :label="navigation.mobileMenuLabel"
        @click="navigation.navigateToRedirect($router)"
      >
        <q-badge
          v-if="navigation.finalRoute === '/news' && unseenNewsCount > 0"
          :label="unseenNewsCount"
          color="red"
          floating
        />
      </q-tab>
    </q-tabs>
  </q-footer>
</template>

<script>
import { isNative } from 'src/config'

export default {
  name: 'MobileFooter',
  data () {
    return {
      tab: null,
      lastViewedNewsAt: null,
      siteSelectorShown: false
    }
  },

  context: ['currentUser'],
  configuration: ['currentSite', 'publishedNewsItems', 'navigations'],

  computed: {
    mobileMenuNavigations () {
      if (isNative) {
        return _.filter(this.navigations?.data, navigation => navigation.showInMobileApp && navigation.visible)
      }
      return _.filter(this.navigations?.data, navigation => navigation.showInMobileMenu && navigation.visible)
    },
    unseenNewsCount () {
      if (this.lastViewedNewsAt) {
        return _.filter(this.publishedNewsItems.data, newsItem => newsItem.publishedAt > this.lastViewedNewsAt).length
      } else {
        return this.publishedNewsItems.data.length
      }
    }
  },
  watch: {
    '$route.path': {
      handler () {
        if (this.$route.path === '/news') {
          this.newsViewed()
        }

        const activeMobileNavigation = _.find(this.mobileMenuNavigations, navigator => navigator.finalRoute === this.$route.path)

        if (activeMobileNavigation) {
          this.tab = activeMobileNavigation.name
        } else {
          // If no match, set tab to null so all tabs are deselected
          this.tab = null
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.initializeViewCount()
  },

  methods: {
    newsViewed () {
      this.lastViewedNewsAt = new Date()
      localStorage.lastViewedNewsAt = this.lastViewedNewsAt.toString()
    },
    initializeViewCount () {
      if (!localStorage.lastViewedNewsAt) return

      this.lastViewedNewsAt = new Date(localStorage.lastViewedNewsAt)
    },
    handleSiteSelectorShown (value) {
      this.siteSelectorShown = value
    }
  }
}
</script>

<style lang="scss">
.overflow-visible .q-tabs__content{
  overflow: visible !important;
}
</style>
